module.exports = __webpack_public_path__ + "static/media/LOGO MEDYCON- BLANCO SOMBRA.fe22f08e.png";